import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as backInter from 'app/auth/auth-data.model';
import { DATOS_API } from 'app/auth/auth.datos';
/// SERVICIO DE AUTENTICACION
import { AuthService } from 'app/auth/auth.service';
import { BehaviorSubject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class WizardService {

  idEmpresa: string;
  idUsuario: string;
  idInfoUser: any;

  private mensajeOrigen = new BehaviorSubject('');
  mensajeActual = this.mensajeOrigen.asObservable();

  constructor(
    private http:HttpClient,
    private authService:AuthService
  ) {
    this.idUsuario = this.authService.getIdUsuario();
    let infoUsu: backInter.infoUsuario = this.authService.getInfoUsuario();
    this.idEmpresa = infoUsu.empresaId;
    this.idInfoUser=infoUsu;
    console.log('infoUsu',infoUsu);
  }

  obtienInfo()
  {
    this.idUsuario = this.authService.getIdUsuario();
    let infoUsu: backInter.infoUsuario = this.authService.getInfoUsuario();
    this.idEmpresa = infoUsu.empresaId;
  }
  getAllStatus(anio: number){
    this.obtienInfo();
    let datos: any = {fechaCertificar: anio,	idiomas: 1};
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getStatuses + this.idEmpresa, datos);
  }

  guardaStatusStep(datos: any){
    this.obtienInfo();
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.guardaStatus + this.idEmpresa, datos);
  }

  puenteDatos(mensaje: string) {
    this.mensajeOrigen.next(mensaje);
  }

  /*getColaboradoresFast(anio: number, producto: string){
    let datos: any = {fechaCertificar: anio, productoId:producto};
    console.log("Datos services");
    console.log(datos);
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.getColaboradoresFast + this.idEmpresa, datos);
  }*/

  getColaboradoresFast(anio: number, producto: string){ // OBTENER COLACORADORES
    this.obtienInfo();
    let datos: any = {fechaNorma35: anio, productoId:producto};
    if (this.idInfoUser.level!=6) {
      return this.http.post(DATOS_API.url + DATOS_API.endpoints.GetColaboradores35 + this.idEmpresa, datos);
}else{
  return this.http.post(DATOS_API.url + DATOS_API.endpoints.GetColaboradores35 + localStorage.getItem('companyID'), datos);
}
  }

  getProdCertAct(){
    this.obtienInfo();
      if (this.idInfoUser.level!=6) {
        return this.http.get(DATOS_API.url + DATOS_API.endpoints.productos + this.idEmpresa);
      }else{
        return this.http.get(DATOS_API.url + DATOS_API.endpoints.productos + localStorage.getItem('companyID'));
      }
  }

  getfiltroNorma(){
    let datos:any = {user: "prro"};
    console.log(DATOS_API.url + DATOS_API.endpoints.getFiltrosConteo);
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.filtroNorma35,datos);

  }

  getDatosEmpresa(){
    this.obtienInfo();
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.resultadosN35.datosEmpresa + this.idEmpresa);
  }

  getDatosEmpresaCentroTrabajo(datos:any){
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.resultadosN35.datosEmpresa + datos);
  }

  getLogoEmpresa(){
    this.obtienInfo();
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.resultadosN35.logoEempresa + this.idEmpresa);
  }

  getCentrosDeTrabajo(datos: any){
      this.obtienInfo();
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.resultadosN35.centrosDeTrabajo + this.idEmpresa, datos);
  }

  getGeneralesCT(urlCTIndividual:any, datos: any){
    this.obtienInfo();
    let idEmpresa;
    if(urlCTIndividual.length>0){
    idEmpresa=urlCTIndividual;
    }
    else{
    idEmpresa=this.idEmpresa;
    }
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.resultadosN35.datosGeneralesCT + idEmpresa, datos);
  }

  getTableros(urlCTIndividual:any, datos: any){
    this.obtienInfo();
    let idEmpresa;
    if(urlCTIndividual.length>0){
    idEmpresa=urlCTIndividual;
    }
    else{
    idEmpresa=this.idEmpresa;
    }
    console.log(datos);
    console.log(idEmpresa);
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.resultadosN35.resultadosTablero + idEmpresa, datos);
  }

  respuestasEncuesta(urlCTIndividual:any, datos: any){
    let idEmpresa;
    if(urlCTIndividual.length>0){
    idEmpresa=urlCTIndividual;
    }
    else{
    idEmpresa=this.idEmpresa;
    }
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.resultadosN35.respuestasEncuesta + idEmpresa, datos);
  }

  respuestasEncuestaFactores(urlCTIndividual:any, datos: any){
    this.obtienInfo();
    let idEmpresa;
    if(urlCTIndividual.length>0){
    idEmpresa=urlCTIndividual;
    }
    else{
    idEmpresa=this.idEmpresa;
    }
    return this.http.post(DATOS_API.url + DATOS_API.endpoints.resultadosN35.respuestasEncuestaFactores + idEmpresa, datos);
  }

  DescargarResultados(productoId,IdCt_numerico){
    this.obtienInfo();
    console.log("Producto id "+productoId);
    console.log("IdCT "+IdCt_numerico);
    console.log("Empresa "+this.idEmpresa);
    return this.http.get(DATOS_API.url + DATOS_API.endpoints.resultadosN35.descargarResultados + this.idEmpresa +'/'+productoId+'/'+IdCt_numerico );
  }


}
